// Convert integer cents with a fixed-point tax factor, including half-cent rounding.
function nsGrossAmount(amount, factor) {
  return Math.round(Math.round(amount * 100) * Math.round(factor * 10000) / 10000) / 100;
}

function nsSingleCurrencyAmount(text) {
  const match = text.trim().match(/^(?:€|EUR)\s*([\d.,]+)$/);
  if (!match) return null;
  let value = match[1];
  const decimal = Math.max(value.lastIndexOf(','), value.lastIndexOf('.'));
  value = decimal >= 0 && value.length - decimal - 1 === 2
    ? value.slice(0, decimal).replace(/[.,]/g, '') + '.' + value.slice(decimal + 1)
    : value.replace(/[.,]/g, '');
  const amount = Number(value);
  return Number.isFinite(amount) ? amount : null;
}

if (!customElements.get('ns-cart-money')) {
  customElements.define('ns-cart-money', class extends HTMLElement {
    connectedCallback() {
      this.source = this.querySelector('[data-ns-money-source]');
      this.output = this.querySelector('[data-ns-money-output]');
      if (!this.source || !this.output) return;
      this.update = () => {
        const price = this.source.querySelector('[data-ymq-money], [ymq-b2b-money]');
        let amount;
        if (price) {
          amount = Number(price.getAttribute('data-ymq-money') || price.getAttribute('ymq-b2b-money'));
        } else {
          let text = this.source.textContent.trim().replace(/[^0-9.,-]/g, '');
          if (!text || !/[0-9]/.test(text)) {
            this.setAttribute('data-locked', '');
            this.source.removeAttribute('aria-hidden');
            return;
          }
          const decimal = Math.max(text.lastIndexOf(','), text.lastIndexOf('.'));
          if (decimal >= 0 && text.length - decimal - 1 === 2) {
            text = text.slice(0, decimal).replace(/[.,]/g, '') + '.' + text.slice(decimal + 1);
          } else {
            text = text.replace(/[.,]/g, '');
          }
          amount = Number(text);
        }
        if (!Number.isFinite(amount)) return;
        this.removeAttribute('data-locked');
        this.source.setAttribute('aria-hidden', 'true');
        const gross = nsGrossAmount(amount, Number(this.dataset.factor));
        this.output.textContent = new Intl.NumberFormat(this.dataset.locale || 'nl', {
          style: 'currency', currency: this.dataset.currency || 'EUR'
        }).format(gross);
      };
      this.observer = new MutationObserver(this.update);
      this.observer.observe(this.source, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-ymq-money', 'ymq-b2b-money'] });
      this.update();
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}

function nsRefreshCatalogPrices() {
  nsCatalogObserver.disconnect();
  document.querySelectorAll('price-list[data-ns-vat-factor]').forEach(list => {
    const factor = Number(list.dataset.nsVatFactor);
    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'nl', {
      style: 'currency', currency: list.dataset.nsCurrency || 'EUR'
    });
    if (list.querySelector('.firstPrice')) {
      // Keep the price app's current net amount (including B2B changes), but round
      // VAT consistently with Liquid and the product's structured price data.
      const net = list.querySelector('.secondPriceValue');
      const gross = list.querySelector('.firstPriceValue');
      const netLabel = list.querySelector('.secondPriceLabel');
      const amount = net ? nsSingleCurrencyAmount(net.textContent) : null;
      if (factor > 1 && gross && /excl/i.test(netLabel?.textContent || '') && amount !== null) {
        const formatted = formatter.format(nsGrossAmount(amount, factor));
        if (gross.textContent !== formatted) gross.textContent = formatted;
      }
      return;
    }
    let count = 0;
    list.querySelectorAll('span.ymq-b2b-price-span, span.ymq-b2b-price-hidden, span.ymq-b2b-current-product-price').forEach(source => {
      if (source.parentElement.closest('span.ymq-b2b-price-span, span.ymq-b2b-price-hidden, span.ymq-b2b-current-product-price')) return;
      const moneyNode = source.matches('[data-ymq-money], [ymq-b2b-money]') ? source : source.querySelector('[data-ymq-money], [ymq-b2b-money]');
      let value = moneyNode?.getAttribute('data-ymq-money') || moneyNode?.getAttribute('ymq-b2b-money');
      if (value == null) {
        const match = source.textContent.match(/(?:€|EUR)\s*([\d.,]+)|([\d.,]+)\s*(?:€|EUR)/);
        if (!match) {
          const previousOutput = source.nextElementSibling;
          if (previousOutput?.matches('[data-ns-gross-value]')) previousOutput.remove();
          source.removeAttribute('data-ns-net-source');
          source.removeAttribute('aria-hidden');
          return;
        }
        value = match[1] || match[2];
        const decimal = Math.max(value.lastIndexOf(','), value.lastIndexOf('.'));
        value = decimal >= 0 && value.length - decimal - 1 === 2
          ? value.slice(0, decimal).replace(/[.,]/g, '') + '.' + value.slice(decimal + 1)
          : value.replace(/[.,]/g, '');
      }
      const amount = Number(value);
      if (!Number.isFinite(amount)) return;
      let output = source.nextElementSibling;
      if (!output?.matches('[data-ns-gross-value]')) {
        output = document.createElement('span');
        output.setAttribute('data-ns-gross-value', '');
        source.after(output);
      }
      const prefix = source.textContent.match(/^(.*?)(?:€|[\d])/u)?.[1]?.trim();
      const formatted = (prefix ? prefix + ' ' : '') + formatter.format(nsGrossAmount(amount, factor));
      if (output.textContent !== formatted) output.textContent = formatted;
      source.setAttribute('data-ns-net-source', '');
      source.setAttribute('aria-hidden', 'true');
      count += 1;
    });
    list.querySelectorAll('[data-ns-gross-value]').forEach(output => {
      if (!output.previousElementSibling?.hasAttribute('data-ns-net-source')) output.remove();
    });
    let label = list.querySelector('[data-ns-catalog-label]');
    if (count > 0 && !label) {
      label = document.createElement('small');
      label.setAttribute('data-ns-catalog-label', '');
      label.textContent = list.dataset.nsVatLabel;
      list.append(label);
    } else if (!count) {
      label?.remove();
    }
  });
  nsCatalogObserver.observe(document.body, { childList: true, subtree: true, characterData: true });
}
let nsCatalogFrame = 0;
const nsCatalogObserver = new MutationObserver(() => {
  if (nsCatalogFrame) return;
  nsCatalogFrame = requestAnimationFrame(() => { nsCatalogFrame = 0; nsRefreshCatalogPrices(); });
});
nsRefreshCatalogPrices();

if (!customElements.get('ns-price-range')) {
  customElements.define('ns-price-range', class extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      this.factor = Number(this.dataset.factor) || 1;
      const options = { signal: this.abortController.signal };
      this.addEventListener('input', event => {
        if (event.target.matches('[data-ns-range]')) this.sync(event.target);
      }, options);
      this.addEventListener('change', event => {
        if (event.target.matches('[data-ns-bound], [data-ns-range]')) this.sync(event.target);
      }, options);
      this.querySelectorAll('[data-ns-bound]').forEach(input => {
        input.addEventListener('focus', () => input.select(), options);
      });
    }
    sync(input) {
      const key = input.dataset.nsBound || input.dataset.nsRange;
      const field = this.querySelector(`[data-ns-bound="${key}"]`);
      const range = this.querySelector(`[data-ns-range="${key}"]`);
      const raw = this.querySelector(`[data-ns-raw="${key}"]`);
      const other = this.querySelector(`[data-ns-bound="${key === 'min' ? 'max' : 'min'}"]`);
      const limit = Number(range.max);
      if (input.value === '' || !Number.isFinite(Number(input.value))) {
        field.value = '';
        raw.value = '';
        range.value = key === 'min' ? '0' : range.max;
      } else {
        let value = Math.min(limit, Math.max(0, Number(input.value)));
        if (other.value !== '') value = key === 'min' ? Math.min(value, Number(other.value)) : Math.max(value, Number(other.value));
        const cents = Math.round(value * 100);
        const rawCents = key === 'min'
          ? Math.max(0, Math.ceil((cents - 0.5) / this.factor))
          : Math.max(0, Math.ceil((cents + 0.5) / this.factor) - 1);
        field.value = (cents / 100).toFixed(2);
        range.value = field.value;
        raw.value = (rawCents / 100).toFixed(2);
      }
      range.parentElement.style.setProperty(`--range-${key}`, `${limit > 0 ? Number(range.value) / limit * 100 : 0}%`);
    }
    disconnectedCallback() { this.abortController?.abort(); }
  });
}
